<template>
  <div>
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">评价</div>
      <div class="nav-right">
        <img class="none" />
      </div>
    </div>

    <div v-for="(item, index) in comment_ary" :key="index">

      <div class="comment-block ub ub-ver">
        <div class="ub ub-pc">
          <img :src="item.photo" class="comment-photo" />
          <span>{{item.nick}}</span>
          <img v-if="item.com_rst=='满意'" src="../../assets/img/好评.png" class="comment-img" />
          <img v-if="item.com_rst=='中等'" src="../../assets/img/中评.png" class="comment-img" />
          <img v-if="item.com_rst=='差评'" src="../../assets/img/差评.png" class="comment-img" />
        </div>
        <span class="comment-txt">{{item.com_dtl}}</span>
        <span class="comment-to">
            <label class="comment-to-nick">{{item.nick1}}</label>
            <label>服务类型:&nbsp;</label>
            <label>{{item.play_type}}&nbsp;&nbsp;</label>
            <label>{{item.play_time_ch}}</label>
        </span>
    </div>

    </div>

    
    

  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      uid_to: "",
      comment_ary: [
        {
          id: "123345346575678",
          photo: "http://xhcapp_i.zhuochuangzb.com/photo/photo_boy/1407.jpg",
          nick: "鸣人",
          comment:"爱了，小姐姐声音真好听。",
          nick2:"东方不败",
          serve_type:"文字语音条一小时",
        },
        {
          id: "123345346575678",
          photo: "http://xhcapp_i.zhuochuangzb.com/photo/photo_boy/1407.jpg",
          nick: "大哥",
          comment:"世界上竟然有这么漂亮的女菩萨。",
          nick2:"东方不败",
          serve_type:"视频三小时",
        },
        {
          id: "123345346575678",
          photo: "http://xhcapp_i.zhuochuangzb.com/photo/photo_boy/1407.jpg",
          nick: "令狐冲",
          comment:"佛系玩家，女菩萨心肠，我只渡人不杀人。",
          nick2:"东方不败",
          serve_type:"王者荣耀三小时",
        },
      ],
    };
  },
  mounted() {
    this.uid_to = this.$route.params.uid_to;
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    back() {
      //this.$router.go(-1); //返回上一层
      this.$router.push({ name: "play_dtl", "params": { "uid_to":this.uid_to} });
    },
    init_page(){
      var self = this;
      self.get({
        url: "/App/Get_Comment_Data/?uid=" + this.uid_to,
        success: function (comm_data) {
         for (var i = 0; i < comm_data.length; i++) {
            comm_data[i].photo = self.$store.state.url + "/photo/" + comm_data[i].photo;
          }
          self.comment_ary = comm_data;
          console.log(JSON.stringify(self.comment_ary));
        },
      });
    }
  },
};
</script>

<style scoped>

.comment-block{
    padding: .8em;
    font-size: .95em;
    color: #333;
    margin: .5em;
    background-color: #fff;
    border-radius: .3em;
}
.comment-photo{
    width: 2.7em;
    height: 2.7em;
    border-radius: 50%;
    margin-right: .5em;
}
.comment-txt{
    margin: .5em 0;
    font-size: 1em;
}
.comment-to{
    font-size: .85em;
    color: rgb(182, 180, 180);
}
.comment-to-nick{
    margin-right: 1.2em;
}
.comment-line{
    padding:0 .8em;
}
.line{
    border-top: 1px solid #f1f1f1;
}
.comment-img{
  width: 2em;
  margin-left: .5em;
}
</style>